import React from 'react';

function AboutPage() {
  return (
    <div className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="section-title">About KSL</h1>
        <div className="prose prose-lg text-gray-700 mx-auto space-y-6">
          <p className="text-xl leading-relaxed">
            Founded in 2022 by a passionate group of architects and engineers, KSL is redefining the future of technology through innovative IT and AI products and services. We combine our deep technical expertise with a creative, problem-solving mindset to deliver intelligent solutions that empower businesses to unlock their full potential.
          </p>
          <p>
            At KSL, we understand that every business is unique. That's why we craft tailored IT and AI strategies designed to streamline operations, enhance decision-making, and fuel sustainable growth. From AI-powered automation and advanced data analytics to secure cloud infrastructure and seamless system integration, our solutions are built to adapt and scale with your evolving needs.
          </p>
          <p>
            Our multidisciplinary team brings a fresh perspective to technology, blending engineering precision with architectural creativity to design solutions that are not only powerful but also elegant and efficient. We're driven by innovation, collaboration, and a commitment to excellence—helping clients transform challenges into opportunities in today's fast-paced digital landscape.
          </p>
          <p>
            Whether you're a startup eager to leverage AI for breakthrough innovation or an established enterprise aiming to modernize your IT ecosystem, KSL is your trusted partner on the journey to digital transformation. Together, we build smarter, more resilient businesses ready for the future.
          </p>
          <p className="font-semibold text-indigo-700">
            Connect with us to explore how our cutting-edge IT and AI solutions can accelerate your success and shape the next chapter of your business.
          </p>
          <p className="mt-8 text-center text-2xl font-bold text-gray-800">
            KSL - Engineering the future of technology with intelligence and creativity.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutPage; 